<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_COURSE"
    title="Lessons"
    sub-title="Manage your lessons"
    :breadcrumbs="breadcrumbs"
    page-name="Lessons"
    align="center"
    width="full"
    action-button-text="Create Lesson"
    @click:action="openCreateLessonModal"
  >
    <SmartFeed :source="useLessonFeedStore" default-feed-layout="table">
      <template #empty-state>
        <iSpace :height="50" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No Lessons Yet
            </iSubHeading>
            <iParagraph variant="subtle" text-align="center" :max-width="400">
              When you create a lesson, it'll appear here for easy access and
              management
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
    <CreateLesson />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import CreateLesson from "@/components/publication/courses/CreateLesson.vue";
import { mapState, mapActions } from "pinia";
import {
  PAGE_PUBLICATION_COURSE,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useCourseStore } from "@/stores/course-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useLessonFeedStore } from "@/smart-feed/stores/feed/lesson-feed-store";

export default {
  name: "PublicationCourse",
  components: { SmartFeed, PageWrapper, CreateLesson },
  data() {
    return {
      PAGE_PUBLICATION_COURSE,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, ["orgId", "publicationId"]),
    ...mapState(useCourseStore, ["course"]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: "Overview",
        },
        {
          url: `/publication/${this.publicationId}/courses`,
          label: `${this.course.name}`,
        },
      ];
    },
  },
  methods: {
    useLessonFeedStore,
    ...mapActions(useCourseStore, ["openCreateLessonModal"]),
  },
};
</script>

<style scoped lang="scss"></style>
